import React, { useState } from "react";
import { Box, Menu, MenuItem, TextField, Typography } from "@mui/material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import getSymbolFromCurrency from "currency-symbol-map";
import { colors, radii } from "../../theme/designTokens";

export default function CurrencyMenu({
  currencyList,
  activeCurrencyName,
  onSelect,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [query, setQuery] = useState("");
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
    setQuery("");
  };

  const filteredList =
    query.trim() === ""
      ? currencyList
      : currencyList.filter((x) =>
          x.currencyName.toLowerCase().includes(query.trim().toLowerCase())
        );

  return (
    <>
      <Box
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          cursor: "pointer",
          bgcolor: colors.white,
          border: `1px solid ${colors.line}`,
          color: colors.ink2,
          borderRadius: radii.full,
          px: 1.25,
          py: 0.6,
          fontSize: 13,
          fontWeight: 700,
          userSelect: "none",
          whiteSpace: "nowrap",
          "&:hover": { bgcolor: colors.primaryLight },
        }}
      >
        {getSymbolFromCurrency(activeCurrencyName) || "$"} {activeCurrencyName || "USD"}
        <KeyboardArrowDownRoundedIcon sx={{ fontSize: 18 }} />
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        autoFocus={false}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        MenuListProps={{ sx: { pt: 0 } }}
        PaperProps={{
          sx: {
            mt: 1,
            borderRadius: radii.md,
            minWidth: 220,
            maxHeight: 360,
            boxShadow: "0 12px 32px rgba(26,37,48,0.18)",
          },
        }}
      >
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 1,
            bgcolor: colors.white,
            px: 1.25,
            py: 1,
            borderBottom: `1px solid ${colors.line}`,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <TextField
            autoFocus
            fullWidth
            size="small"
            placeholder="Search currency..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <SearchRoundedIcon sx={{ fontSize: 18, color: colors.ink3, mr: 0.5 }} />
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                bgcolor: colors.paperTint,
                borderRadius: radii.md,
                fontSize: 14,
                "& fieldset": { border: "none" },
              },
            }}
          />
        </Box>
        {filteredList.length > 0 ? (
          filteredList.map((x, i) => (
            <MenuItem
              key={i}
              selected={x.currencyName === activeCurrencyName}
              onClick={() => {
                onSelect(x);
                handleClose();
              }}
              sx={{
                gap: 1,
                "&.Mui-selected": {
                  bgcolor: colors.primaryLight,
                  "&:hover": { bgcolor: colors.primaryLight },
                },
              }}
            >
              <Typography sx={{ fontSize: 14, fontWeight: 600, color: colors.ink2 }}>
                ({getSymbolFromCurrency(x.currencyName)}) {x.currencyName}
              </Typography>
            </MenuItem>
          ))
        ) : (
          <Typography
            sx={{ px: 2, py: 1.5, fontSize: 13.5, color: colors.ink3 }}
          >
            No currency found
          </Typography>
        )}
      </Menu>
    </>
  );
}
